import mixCutDetailStore from "@/stores/mixCutDetailStore";
import { IOrigin } from "@/stores/mixCutDetailStore/type";
import { toJS } from "mobx";
import { v4 as uuid } from "uuid";
import QuickCutStore from "@/stores/quickCutStore";
// 获取所有json
// 开始是否global
// 设置ProjectMsg

const convertDurationsToMilliseconds = (jsonData) => {
  const result = JSON.parse(JSON.stringify(jsonData)); // 创建深拷贝

  Object.keys(result).forEach(key => {
    if (result[key].duration !== undefined) {
      result[key].duration = Math.round(result[key].duration * 1000);
    }
  });

  return result;
}
const useMixCutDetail = () => {
  const handelProjectGlobalChange = (e: boolean) => {
    mixCutDetailStore.setProjectIsGolbal(e);
  };

  const convertDurationsToMilliseconds = (jsonData) => {
    const result = JSON.parse(JSON.stringify(jsonData)); // 创建深拷贝
    Object.keys(result).forEach(key => {
      if (result[key].duration !== undefined) {
        result[key].duration = Math.round(result[key].duration * 1000);
      }
    });
    return result;
  }

  const handleGetOriginJson = () => {
    const _materials = {};
    (
      Object.keys(mixCutDetailStore.getProjectMaterialsInfo() || {}) || []
    ).forEach((item) => {
      _materials[item] = {
        url: "",
        cover: "",
      };
    });
    return {
      ...QuickCutStore.quickcutData,
      transitions: convertDurationsToMilliseconds(QuickCutStore.quickcutData.transitions)
    };
  };

  return {
    handelProjectGlobalChange,
    handleGetOriginJson,
    handleProjectMsgSet: mixCutDetailStore.setProjectMsg,
    projectMsg: mixCutDetailStore.getProjectMsg(),
  };
};

export default useMixCutDetail;
